<script>
export default {
    props: {
        acount: Object
    },
    data() {
        return {
            info: {
                pwd: '',
                rePwd: ''
            },
            error: {
                pwd: '',
                rePwd: ''
            }
        }
    },
    methods: {
        async confirm() {            
            this.error.pwd = ''
            this.error.rePwd = ''
            let shouldBlock = false
            if (!this.info.pwd) {
                shouldBlock = true
                this.error.pwd = '请输入密码'
            }
            if (this.info.pwd.length > 32) {
                shouldBlock = true
                this.error.pwd = '密码长度不应超过32位'
            }
            if (!this.info.rePwd) {
                shouldBlock = true
                this.error.rePwd = '请确认密码'
            }
            if (this.info.pwd && this.info.rePwd && this.info.pwd != this.info.rePwd) {
                shouldBlock = true
                this.error.rePwd = '两次输入的密码不一致'
            }
            if (shouldBlock) {
                return
            }
            let result = await this.$http.updateAcount(this.acount.id, {
                resetPassword: this.info.rePwd
            }, true)
            if (result) {
                this.$emit('close')
            }
        }
    }
}
</script>

<template>
    <Dialog btn-text="提交" title="重置密码" @close="$emit('close')" @confirm="confirm" >
        <DialogInput name="重置密码" type="password" v-model="info.pwd" :error="error.pwd" />
        <DialogInput name="确认密码" type="password" v-model="info.rePwd" :error="error.rePwd" @keyup.enter.native="confirm" />
    </Dialog>
</template>


<style lang="scss" scoped>
.DialogInput {
    margin: 0px 21px;
}
</style>




// WEBPACK FOOTER //
// src/components/acount/ResetPwdDialog.vue